import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useVarietiesByCustomer } from '../../../../services/entities/hooks/useVarietiesByCustomer';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { LoadingListSkeleton } from '../../../../sprouts/components/LoadingListSkeleton/LoadingListSkeleton';
import { ExpandableMenu } from '../../../commonUI/Menu/ExpandableMenu';
import { MenuPaper } from '../../../commonUI/Menu/MenuPaper';
import { REPORT_SUPPORTED_CROP_TYPES } from '../../constants';

type Props = {
  customerId: string;
};

export const BlueberryReportsList = ({ customerId }: Props) => {
  const { t } = useTranslation();

  const { varieties, isVarietiesLoading } = useVarietiesByCustomer(
    customerId,
    REPORT_SUPPORTED_CROP_TYPES
  );

  return (
    <MenuPaper sx={{ width: '100%', padding: 0 }}>
      <Stack sx={{ width: '100%', gap: 2 }}>
        <ExpandableMenu title={t('Varieties')} expanded={true}>
          <Stack
            sx={(theme) => ({
              color: theme.palette.text.primary,
              padding: 4,
              paddingTop: 0,
              paddingLeft: 8,
              gap: 4,
            })}
          >
            {isVarietiesLoading ? (
              <Box sx={{ width: '30%' }}>
                <LoadingListSkeleton />
              </Box>
            ) : varieties?.length ? (
              varieties?.map((variety) => (
                <Link
                  key={variety.id}
                  component={RouterLink}
                  to={`blueberry/${variety.id}`}
                >
                  <Typography
                    variant='body2'
                    sx={(theme) => ({
                      color: theme.vars.palette.text.primary,
                    })}
                  >
                    {variety.name}
                  </Typography>
                </Link>
              ))
            ) : (
              <Typography variant='body2' color='textSecondary'>
                {t('No blueberry varieties found')}
              </Typography>
            )}
          </Stack>
        </ExpandableMenu>
      </Stack>
    </MenuPaper>
  );
};
